import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC2glpeIzaR7QshG-CBdkm3kUcScGQLNeg",
  authDomain: "medicare-plan-guardian.firebaseapp.com",
  projectId: "medicare-plan-guardian",
  storageBucket: "medicare-plan-guardian.firebasestorage.app",
  messagingSenderId: "814890815683",
  appId: "1:814890815683:web:3697747505f9a1eb255276"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);